export default __webpack_public_path__ + "static/media/React-Portfolio.15540a73.jpg";